import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../actions";
import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import Header from "./Header";
import Login from "./Login";
import Spinner from "./app/Spinner";
import Dashboard from "./Dashboard";

import Account from "./account/Account";
import Customers from "./customers/Customers";
import DisplayManager from "./menus/DisplayManager";
import Displays from "./menus/Displays";
import GroupEdit from "./menus/GroupEdit";
import Groups from "./menus/Groups";
import Grow from "./grow/Grow";
import LocationManager from "./menus/LocationManager";
import ManageBrands from "./menus/ManageBrands";
import ManageColors from "./menus/ManageColors";
import ManageCategories from "./menus/ManageCategories";
import ManageTerpeneProfiles from "./menus/ManageTerpeneProfiles";
import Media from "./menus/Media";
import MenuConfig from "./menus/MenuConfig";
import MenuEdit from "./menus/MenuEdit";
import Menus from "./menus/Menus";
import Payments from "./payments/Payments";
import Reports from "./reports/Reports";
import Security from "./security/Security";
import Settings from "./settings/Settings";
import Subscriptions from "./subscriptions/Subscriptions";
import SurveyNew from "./surveys/SurveyNew";
import UserManager from "./menus/UserManager";

import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      form: null,
      open: false,
      account: false,
      location: []
    };
  }

  componentDidMount() {
    this.props.fetchUser();
  }

  renderContent() {
    switch (this.props.auth) {
      case null:
        return <Spinner />;
      case false:
        return <Login />;
      default:
        return (
          <div>
            <Header />
            <Route exact path="/" component={LocationManager} />
            <Route path="/account" component={Account} />
            <Route path="/customers" component={Customers} />
            <Route path="/dashboard" component={Dashboard} />
            <Route exact path="/locations/:id/users" component={UserManager} />
            <Route
              exact
              path="/menus/groups/:groupID/edit"
              component={GroupEdit}
            />
            <Route exact path="/menus/groups" component={Groups} />
            <Route path="/grow" component={Grow} />
            <Route exact path="/menus/config/brand" component={ManageBrands} />
            <Route exact path="/menus/config/colors" component={ManageColors} />
            <Route
              exact
              path="/menus/config/category"
              component={ManageCategories}
            />
            <Route
              exact
              path="/menus/config/terpeneprofiles"
              component={ManageTerpeneProfiles}
            />
            <Route exact path="/menus/media" component={Media} />
            <Route exact path="/menus/:menuID/edit" component={MenuEdit} />
            <Route exact path="/menus" component={Menus} />
            <Route exact path="/menus/config" component={MenuConfig} />
            <Route
              exact
              path="/menus/displays/:displayID/edit"
              component={DisplayManager}
            />
            <Route exact path="/menus/displays" component={Displays} />
            <Route path="/payments" component={Payments} />
            <Route path="/reports" component={Reports} />
            <Route path="/security" component={Security} />
            <Route path="/settings" component={Settings} />
            <Route path="/subscriptions" component={Subscriptions} />
            <Route path="/surveys/new" component={SurveyNew} />
          </div>
        );
    }
  }

  render() {
    let loggedin = false;
    if (this.props.auth) {
      loggedin = true;
    }
    return (
      <div className={`app-component sidebar-${loggedin}`}>
        <BrowserRouter>
          <DragDropContextProvider backend={HTML5Backend}>
            <div className="container">{this.renderContent()}</div>
          </DragDropContextProvider>
        </BrowserRouter>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

App.propTypes = {
  //classes: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object
  //theme: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  actions
)(App);
